<script setup>
definePage({
  meta: {
    action: 'read',
    subject: 'bots',
    useBotNav: true,
  },
})

import { useRoute } from 'vue-router'

// Get the bot ID from the route params
const route = useRoute()
const botId = route.params.id
</script>

<template>
  <div>
    <h1>Bot Details</h1>
    <p>Bot ID: {{ botId }}</p>
  </div>
</template>
